import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { COPY } from './copy';
import { compactMoney } from './format';

// A valuation the coach ran after the owner already had an active one: a
// scenario, saved but not used anywhere until the owner presses the button
// (SmbValuations::SetActive). `scenario.active` comes from the server, so
// the card stays right after a reload or a change in the Valuation Studio.
export default function ValuationScenario({ scenario, onActivate }) {
  const [status, setStatus] = useState(null); // 'saving' | 'error'
  const active = scenario.active;
  const current = scenario.active_valuation;

  const activate = async () => {
    setStatus('saving');
    try {
      setStatus((await onActivate(scenario)) ? null : 'error');
    } catch (e) {
      setStatus('error');
    }
  };

  return (
    <div
      data-testid={`valuation-scenario-${scenario.valuation_snapshot_id}`}
      className={`flex flex-wrap items-center border rounded-xl py-4 px-[18px] gap-y-3.5 gap-x-5 ${
        active ? 'border-[hsl(var(--chart-2)/0.35)] bg-[hsl(var(--chart-2)/0.06)]' : 'border-border bg-card'
      }`}
    >
      <div className="flex flex-col flex-1 min-w-[230px] gap-1.5">
        <span className="font-label text-[10px] tracking-[0.06em] uppercase text-muted-foreground">{COPY.scenarioEyebrow}</span>
        <span className="text-[22px] font-light tracking-[-0.02em] tabular-nums">
          {compactMoney(scenario.value || 0)}
          <span className="ml-2 text-[13px] text-muted-foreground tracking-normal">
            range {compactMoney(scenario.low || 0)} – {compactMoney(scenario.high || 0)}
          </span>
        </span>
        {!active && current?.value ? (
          <span className="text-[13px] text-muted-foreground tabular-nums">{COPY.scenarioCompare(compactMoney(current.value))}</span>
        ) : null}
        {!active && <span className="text-[13px] leading-normal text-muted-foreground">{COPY.scenarioHint}</span>}
      </div>
      {active ? (
        <span className="inline-flex items-center gap-1.5 text-[13px] font-medium text-teal-ink">
          <CheckCircle2 size={16} /> {COPY.nowActive}
        </span>
      ) : (
        <button
          type="button"
          className="min-h-9 px-[18px] rounded-full border-0 bg-orange-cta text-white text-[13px] font-medium cursor-pointer"
          disabled={status === 'saving' || !onActivate}
          onClick={activate}
        >
          {status === 'saving' ? COPY.makingActive : COPY.makeActive}
        </button>
      )}
      {status === 'error' && (
        <span className="w-full text-[12px] text-coral-ink">That didn't save. Please try again.</span>
      )}
    </div>
  );
}
